module.exports = __webpack_public_path__ + "static/Migra-Variable-c8fe9ba6025e968efe4f02c38cb57c90.ttf";